import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 82px;
  height: 28px;
  background-color: #3cd3c1;
  color: #ffffff;
  font-size: 16px;
  padding: 6px;
  font-weight: 600;
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  margin: -10px 12px 0 0;
  cursor: pointer;
`
